import { render, staticRenderFns } from "./goal.vue?vue&type=template&id=51180eae"
import script from "./goal.vue?vue&type=script&lang=js"
export * from "./goal.vue?vue&type=script&lang=js"
import style0 from "./goal.vue?vue&type=style&index=0&id=51180eae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports